export const money = (n) =>
  n == null ? "—" : n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

export const compactMoney = (n) => {
  if (n == null) return "—";
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 2).replace(/\.?0+$/, "")}M`;
  return `$${Math.round(n / 1000)}K`;
};

export const miles = (m) => (m == null ? "—" : `${m.toFixed(1)} mi`);

export const directionsUrl = (from, to) =>
  `https://www.google.com/maps/dir/?api=1&origin=${from.lat},${from.lng}&destination=${to.lat},${to.lng}&travelmode=driving`;

// VA funding fee (purchase loans) — published VA schedule; borrowers with a service-connected disability are exempt.
export function vaFundingFeeRate(downPct, use) {
  if (use === "exempt") return 0;
  if (downPct >= 10) return 1.25;
  if (downPct >= 5) return 1.5;
  return use === "subsequent" ? 3.3 : 2.15;
}

export function monthlyPI(principal, ratePct, years) {
  const r = ratePct / 100 / 12;
  const n = years * 12;
  if (principal <= 0) return 0;
  if (r === 0) return principal / n;
  return (principal * r) / (1 - Math.pow(1 + r, -n));
}

/** Estimate a monthly payment. All rates are user inputs, not quotes. */
export function estimatePayment({ price, downPct, ratePct, years, loanType, vaUse, taxPct, insuranceMonthly, hoaMonthly = 0 }) {
  const down = (price * downPct) / 100;
  let loan = price - down;
  let upfrontFee = 0;
  let mortgageInsurance = 0;
  if (loanType === "va") {
    upfrontFee = (loan * vaFundingFeeRate(downPct, vaUse)) / 100;
    loan += upfrontFee; // funding fee typically financed
  } else if (loanType === "fha") {
    upfrontFee = loan * 0.0175;
    loan += upfrontFee;
    mortgageInsurance = (loan * 0.0055) / 12;
  } else if (downPct < 20) {
    mortgageInsurance = (loan * 0.005) / 12;
  }
  const pi = monthlyPI(loan, ratePct, years);
  const tax = (price * taxPct) / 100 / 12;
  const total = pi + tax + insuranceMonthly + mortgageInsurance + hoaMonthly;
  return { down, loan, upfrontFee, pi, tax, insurance: insuranceMonthly, mortgageInsurance, hoa: hoaMonthly, total };
}
